module.exports = __webpack_public_path__ + "static/media/msmarking.7cae127c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/Logos_Lieferanten/msmarking.png
// module id = 395
// module chunks = 0